import axiosInstance from '../../../../services/api';

const MULTICHOIX_API_ENDPOINT = '/api/treatments/multichoix/';

/**
 * Service for fetching multichoix step options from the dedicated API.
 * Each step's options are filtered by all previous selections.
 */
export const multichoixService = {
  /**
   * Fetch options for a specific step
   * @param {number} step - Step number (1-6)
   * @param {Object} previousSelections - All selections from previous steps
   * @returns {Promise<{options: Array, total: number}>}
   */
  async getStepOptions(step, previousSelections = {}) {
    const params = new URLSearchParams();
    params.append('step', step.toString());

    // Add all previous selections as filter params
    if (previousSelections.cultures?.length > 0) {
      params.append('cultures', previousSelections.cultures.join(','));
    }
    if (previousSelections.cultural_practices?.length > 0) {
      params.append('cultural_practices', previousSelections.cultural_practices.join(','));
    }
    if (previousSelections.treatment_type?.length > 0) {
      params.append('treatment_type', previousSelections.treatment_type.join(','));
    }
    if (previousSelections.enemies?.length > 0) {
      params.append('enemies', previousSelections.enemies.join(','));
    }
    if (previousSelections.intervention_period?.length > 0) {
      params.append('intervention_period', previousSelections.intervention_period.join(','));
    }

    try {
      const { data } = await axiosInstance.get(
        `${MULTICHOIX_API_ENDPOINT}?${params.toString()}`
      );

      return {
        options: data.options || [],
        total: data.total || 0,
      };
    } catch (error) {
      console.error('Error fetching multichoix step options:', error);
      throw error;
    }
  },

  /**
   * Transform allSelections object to the format expected by the API
   * Maps frontend field names to API parameter names
   * @param {Object} allSelections - Selections using frontend field names
   * @returns {Object} Selections using API parameter names
   */
  transformSelectionsForApi(allSelections) {
    return {
      cultures: allSelections['treatment_cultures.culture'] || [],
      cultural_practices: allSelections['treatment_cultures.cultural_practices'] || [],
      treatment_type: allSelections['treatment_type'] || [],
      enemies: allSelections['treatment_enemies.enemy'] || [],
      intervention_period: allSelections['intervention_period'] || [],
    };
  },
};

/**
 * Query keys for React Query caching
 */
export const multichoixKeys = {
  all: ['multichoix'],
  stepOptions: (step, selections) => [...multichoixKeys.all, 'step', step, selections],
};

export default multichoixService;
